import React, { useEffect, useState } from 'react'

import { string } from 'prop-types'

let ConferenceSignInModal = null
let conferenceSignInModalImportPromise = null

export const importConferenceSignInModal = () => {
  if (!conferenceSignInModalImportPromise) {
    conferenceSignInModalImportPromise = import(
      /* webpackChunkName: "conference-sign-in-modal" */
      'Pods/LazyLoaded/ConferenceSignInModal/ConferenceSignInModal'
    ).then((mod) => { ConferenceSignInModal = mod.default })
  }
  return conferenceSignInModalImportPromise
}

function LazyConferenceSignInModal({ eventName }) {
  const [isLoaded, setIsLoaded] = useState(() => !!ConferenceSignInModal)

  useEffect(() => {
    if (!ConferenceSignInModal) {
      importConferenceSignInModal().then(() => setIsLoaded(true))
    }
  }, [])

  if (!isLoaded || !ConferenceSignInModal) return null
  return <ConferenceSignInModal eventName={eventName} />
}

LazyConferenceSignInModal.propTypes = {
  eventName: string.isRequired,
}

export default LazyConferenceSignInModal
